import {
  DestroyRef,
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Subject, throttleTime } from 'rxjs';

@Directive({
  standalone: true,
  selector: '[ptInfiniteScroll]',
})
export class InfiniteScrollDirective implements OnInit {
  #elementRef = inject(ElementRef);
  #destroyRef = inject(DestroyRef);

  #debounced = new Subject<void>();

  disabled = input<boolean>(false);
  threshold = input<number>(0.3);

  scrolled = output<void>();

  @HostListener('scroll')
  windowScrollEvent(): void {
    const scrollHeight = this.#elementRef.nativeElement.scrollHeight;
    const elementHeight = this.#elementRef.nativeElement.offsetHeight;
    const top = this.#elementRef.nativeElement.scrollTop;

    const scrollToTop = scrollHeight - elementHeight + top;

    if (scrollToTop < elementHeight * this.threshold() && !this.disabled()) {
      this.#debounced.next();
    }
  }

  ngOnInit() {
    this.#debounced
      .pipe(throttleTime(500), takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => !this.disabled() && this.scrolled.emit());
  }
}
